/**
 * Configuration des équipements souhaités par profil de bien
 * Ces équipements sont alignés sur les champs des biens pour permettre le matching automatique
 * 
 * Structure: chaque équipement a un mapping vers le champ du bien correspondant
 */

// Équipements communs à tous les profils
export const EQUIPEMENTS_COMMUNS = [
  {
    id: 'climatisation',
    label: 'Climatisation',
    fieldPath: 'composition.equipements.climatisation',
    icon: ''
  },
  {
    id: 'pmr_accessible',
    label: 'Accessible PMR',
    fieldPath: 'composition.accessibilite.pmr_accessible',
    icon: ''
  },
  {
    id: 'parking',
    label: 'Parking',
    fieldPath: 'composition.acces.parking_places',
    matchType: 'exists', // Le bien doit avoir parking_places > 0
    icon: ''
  },
  {
    id: 'fibre_optique',
    label: 'Fibre optique',
    fieldPath: 'composition.equipements.fibre_optique',
    matchValue: 'oui', // Le bien doit avoir fibre_optique == "oui"
    icon: ''
  }
];

// Équipements spécifiques CHR (Cafés, Hôtels, Restaurants)
export const EQUIPEMENTS_CHR = [
  {
    id: 'terrasse',
    label: 'Terrasse',
    fieldPath: 'composition.chr.terrasse_existe',
    icon: ''
  },
  {
    id: 'extraction',
    label: 'Extraction',
    fieldPath: 'composition.chr.extraction_existe',
    icon: ''
  },
  {
    id: 'cuisine_equipee',
    label: 'Cuisine équipée',
    fieldPath: 'composition.chr.cuisine_type',
    matchType: 'exists',
    icon: ''
  },
  {
    id: 'gaz',
    label: 'Gaz',
    fieldPath: 'composition.chr.gaz_existe',
    icon: ''
  },
  {
    id: 'electricite_tri',
    label: 'Électricité triphasée',
    fieldPath: 'composition.chr.electricite_tri',
    icon: ''
  },
  {
    id: 'chambre_froide',
    label: 'Chambre froide',
    fieldPath: 'composition.chr.chambre_froide',
    matchType: 'not_equals',
    matchValue: 'aucune',
    icon: ''
  },
  {
    id: 'bar',
    label: 'Bar / Comptoir',
    fieldPath: 'composition.chr.bar_existe',
    icon: ''
  },
  {
    id: 'licence_4',
    label: 'Licence IV',
    fieldPath: 'licence.licence_type',
    matchValue: 'IV',
    icon: ''
  },
  {
    id: 'tireuse_biere',
    label: 'Tireuse bière',
    fieldPath: 'composition.chr.tireuse_biere',
    icon: ''
  }
];

// Équipements spécifiques Retail (Commerce)
export const EQUIPEMENTS_RETAIL = [
  {
    id: 'vitrine',
    label: 'Vitrine',
    fieldPath: 'composition.retail.lineaire_vitrine_m',
    matchType: 'exists',
    icon: ''
  },
  {
    id: 'double_vitrine',
    label: 'Double vitrine',
    fieldPath: 'composition.retail.double_vitrine',
    icon: ''
  },
  {
    id: 'angle_rue',
    label: 'Angle de rue',
    fieldPath: 'composition.retail.angle_rue',
    icon: ''
  },
  {
    id: 'reserve',
    label: 'Réserve',
    fieldPath: 'composition.surfaces.surface_reserve_m2',
    matchType: 'exists',
    icon: ''
  },
  {
    id: 'rideau_metal',
    label: 'Rideau métallique',
    fieldPath: 'composition.retail.rideau_metal',
    icon: ''
  },
  {
    id: 'alarme',
    label: 'Alarme',
    fieldPath: 'composition.retail.alarme',
    icon: ''
  },
  {
    id: 'reserve_securisee',
    label: 'Réserve sécurisée',
    fieldPath: 'composition.retail.reserve_securisee',
    icon: ''
  },
  {
    id: 'proximite_transports',
    label: 'Proximité transports',
    fieldPath: 'composition.retail.proximite_transports',
    icon: ''
  }
];

// Équipements spécifiques Bureaux
export const EQUIPEMENTS_BUREAUX = [
  {
    id: 'ascenseur',
    label: 'Ascenseur',
    fieldPath: 'composition.acces.ascenseur',
    icon: ''
  },
  {
    id: 'salles_reunion',
    label: 'Salles de réunion',
    fieldPath: 'composition.capacites.salles_reunion_nombre',
    matchType: 'exists',
    icon: ''
  },
  {
    id: 'faux_plancher',
    label: 'Faux plancher',
    fieldPath: 'composition.bureaux.faux_plancher',
    icon: ''
  },
  {
    id: 'faux_plafond',
    label: 'Faux plafond',
    fieldPath: 'composition.bureaux.faux_plafond',
    icon: ''
  },
  {
    id: 'cablage_rj45',
    label: 'Câblage RJ45',
    fieldPath: 'composition.bureaux.cablage_rj45',
    icon: ''
  },
  {
    id: 'controle_acces',
    label: 'Contrôle d\'accès',
    fieldPath: 'composition.acces.controle_acces',
    matchType: 'not_equals',
    matchValue: 'aucun',
    icon: ''
  },
  {
    id: 'divisible',
    label: 'Divisible',
    fieldPath: 'composition.bureaux.divisible',
    icon: ''
  }
];

// Équipements spécifiques Activité / Logistique / Entrepôt
export const EQUIPEMENTS_ACTIVITE = [
  {
    id: 'quais_chargement',
    label: 'Quais de chargement',
    fieldPath: 'composition.activite.quais_chargement_nombre',
    matchType: 'exists',
    icon: ''
  },
  {
    id: 'plain_pied',
    label: 'Plain-pied',
    fieldPath: 'composition.activite.plain_pied',
    icon: ''
  },
  {
    id: 'pont_roulant',
    label: 'Pont roulant',
    fieldPath: 'composition.activite.pont_roulant',
    icon: ''
  },
  {
    id: 'aire_manoeuvre',
    label: 'Aire de manœuvre',
    fieldPath: 'composition.activite.aire_manoeuvre',
    icon: ''
  },
  {
    id: 'portes_sectionnelles',
    label: 'Portes sectionnelles',
    fieldPath: 'composition.activite.portes_sectionnelles_nombre',
    matchType: 'exists',
    icon: ''
  },
  {
    id: 'hauteur_libre',
    label: 'Grande hauteur (>6m)',
    fieldPath: 'composition.activite.hauteur_libre_m',
    matchType: 'greater_than',
    matchValue: 6,
    icon: ''
  }
];

// Mapping profil → équipements disponibles
export const EQUIPEMENTS_PAR_PROFIL = {
  chr: {
    label: 'CHR / Restauration',
    equipements: [...EQUIPEMENTS_COMMUNS, ...EQUIPEMENTS_CHR]
  },
  retail: {
    label: 'Commerce / Retail',
    equipements: [...EQUIPEMENTS_COMMUNS, ...EQUIPEMENTS_RETAIL]
  },
  bureaux: {
    label: 'Bureaux / Tertiaire',
    equipements: [...EQUIPEMENTS_COMMUNS, ...EQUIPEMENTS_BUREAUX]
  },
  activite_logistique: {
    label: 'Local d\'activité / Entrepôt',
    equipements: [...EQUIPEMENTS_COMMUNS, ...EQUIPEMENTS_ACTIVITE]
  }
};

// Types de transaction alignés sur la taxonomie des biens
export const TYPES_OPERATIONS = [
  { value: 'cession', label: 'Cession (Achat)' },
  { value: 'location', label: 'Location' },
  { value: 'location_droit_entree', label: 'Location avec pas-de-porte' },
  { value: 'location_gerance', label: 'Location-gérance' },
  { value: 'vente_immo', label: 'Vente immobilière (Murs)' }
];

// Types de biens alignés sur la taxonomie
export const TYPES_BIENS = [
  { value: 'fonds_de_commerce', label: 'Fonds de commerce' },
  { value: 'droit_au_bail', label: 'Droit au bail' },
  { value: 'murs_commerciaux', label: 'Murs commerciaux' },
  { value: 'titres_societe', label: 'Titres de société' }
];

// Profils de biens
export const PROFILS_BIENS = [
  { value: 'chr', label: 'CHR / Restauration' },
  { value: 'retail', label: 'Commerce / Retail' },
  { value: 'bureaux', label: 'Bureaux / Tertiaire' },
  { value: 'activite_logistique', label: 'Local d\'activité / Entrepôt' }
];

/**
 * Récupère les équipements disponibles pour un profil donné
 * @param {string} profil - Le profil du bien (chr, retail, bureaux, activite_logistique)
 * @returns {Array} Liste des équipements disponibles
 */
export const getEquipementsForProfil = (profil) => {
  if (!profil || !EQUIPEMENTS_PAR_PROFIL[profil]) {
    // Si pas de profil spécifié, retourner uniquement les équipements communs
    return EQUIPEMENTS_COMMUNS;
  }
  return EQUIPEMENTS_PAR_PROFIL[profil].equipements;
};

/**
 * Convertit les équipements souhaités en objet pour la sauvegarde
 * @param {Array} selectedIds - IDs des équipements sélectionnés
 * @returns {Object} Objet avec les équipements souhaités
 */
export const equipementsArrayToObject = (selectedIds) => {
  if (!selectedIds || selectedIds.length === 0) return null;
  
  const result = {};
  selectedIds.forEach(id => {
    result[id] = true;
  });
  return result;
};

/**
 * Convertit l'objet équipements en tableau d'IDs pour l'UI
 * @param {Object} equipementsObj - Objet des équipements souhaités
 * @returns {Array} Tableau des IDs sélectionnés
 */
export const equipementsObjectToArray = (equipementsObj) => {
  if (!equipementsObj) return [];
  
  return Object.entries(equipementsObj)
    .filter(([_, value]) => value === true)
    .map(([key]) => key);
};

export default {
  EQUIPEMENTS_COMMUNS,
  EQUIPEMENTS_CHR,
  EQUIPEMENTS_RETAIL,
  EQUIPEMENTS_BUREAUX,
  EQUIPEMENTS_ACTIVITE,
  EQUIPEMENTS_PAR_PROFIL,
  TYPES_OPERATIONS,
  TYPES_BIENS,
  PROFILS_BIENS,
  getEquipementsForProfil,
  equipementsArrayToObject,
  equipementsObjectToArray
};
